import { render } from "./MinimumProfileForm.vue?vue&type=template&id=366f9cd2&scoped=true"
import script from "./MinimumProfileForm.vue?vue&type=script&lang=js"
export * from "./MinimumProfileForm.vue?vue&type=script&lang=js"

import "./MinimumProfileForm.vue?vue&type=style&index=0&id=366f9cd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366f9cd2"]])

export default __exports__